import { createContext, useContext, type ReactNode } from "react";
import type { MeUser } from "./api";
import { useSession } from "./useSession";

export type AuthContextValue = {
  user: MeUser | null | undefined;
  isAdmin: boolean;
  impersonator: { id: string; email: string } | null;
  loading: boolean;
  refresh: () => Promise<void>;
};

const SessionContext = createContext<AuthContextValue | null>(null);

export function SessionProvider({ children }: { children: ReactNode }) {
  const value = useSession();
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useAuth(): AuthContextValue {
  const ctx = useContext(SessionContext);
  if (!ctx) {
    throw new Error("useAuth must be used within SessionProvider");
  }
  return ctx;
}
